import React from 'react';
import { motion } from 'framer-motion';
interface TestimonialsSectionProps {
  checkoutUrl: string;
}
export const TestimonialsSection = ({
  checkoutUrl
}: TestimonialsSectionProps) => {
  const videos = [{
    id: '1',
    embedUrl: 'https://player.vimeo.com/video/1138437313'
  }, {
    id: '2',
    embedUrl: 'https://player.vimeo.com/video/1138437328'
  }, {
    id: '3',
    embedUrl: 'https://player.vimeo.com/video/1138438331'
  }];
  return <section className="w-full py-8 sm:py-12 px-4 bg-gray-50" data-id="element-217">
      <div className="container mx-auto max-w-6xl" data-id="element-218">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6 sm:mb-10" data-id="element-219">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-black mb-3" data-id="element-220">
            ¿Qué dicen otras personas de nuestros servicios?
          </h2>
          <div className="h-1 w-20 bg-[#7A3EFF] mx-auto rounded-full" data-id="element-221" />
        </motion.div>
        <div className="flex flex-col items-center gap-6 sm:gap-8" data-id="element-222">
          {videos.map((video, index) => <motion.div key={video.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className="w-full max-w-[600px] bg-white rounded-2xl shadow-lg p-4 sm:p-5" data-id="element-223">
              <div className="relative w-full overflow-hidden rounded-xl" style={{
            paddingBottom: '56.25%'
          }} data-id="element-224">
                <iframe src={video.embedUrl} className="absolute inset-0 w-full h-full" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title={`Testimonial video ${index + 1}`} data-id="element-225" />
              </div>
            </motion.div>)}
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex justify-center mt-8 sm:mt-10" data-id="element-226">
          <motion.a href={checkoutUrl} target="_blank" rel="noopener noreferrer" className="inline-block px-10 sm:px-14 py-4 bg-white text-[#7B2BFD] text-lg sm:text-xl font-bold rounded-full transition-all duration-300" style={{
          border: '3px solid #7B2BFD',
          boxShadow: '0 0 20px rgba(123, 43, 253, 0.4), 0 0 40px rgba(123, 43, 253, 0.2)'
        }} animate={{
          scale: [1, 1.05, 1]
        }} transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'easeInOut'
        }} whileHover={{
          scale: 1.08,
          boxShadow: '0 0 30px rgba(123, 43, 253, 0.6), 0 0 60px rgba(123, 43, 253, 0.4)'
        }} whileTap={{
          scale: 0.95
        }} data-id="element-227">
            RESERVAR MI CUPO
          </motion.a>
        </motion.div>
      </div>
    </section>;
};